import client from '@sanity/client';
export default client({
    projectId: 'slogrcw8',
    dataset: 'production',
})